/**
 * Brand logo component for oRdeN.
 * Variants:
 *  - 'badge' (default): square rounded purple background with logo (header use)
 *  - 'plain': raw logo image (white/transparent surfaces)
 *  - 'wordmark': logo + "oRdeN" text side by side
 */
export function Logo({ size = 40, variant = "badge", className = "" }) {
  const src = "/logo.png";
  if (variant === "plain") {
    return <img src={src} alt="oRdeN" width={size} height={size} className={className} style={{ width: size, height: size, objectFit: "contain" }} />;
  }
  if (variant === "wordmark") {
    return (
      <div className={`inline-flex items-center gap-3 ${className}`}>
        <img src={src} alt="oRdeN" style={{ width: size, height: size, objectFit: "contain" }} />
        <span className="font-display text-xl font-bold tracking-tight text-[#1a0f2e]" data-testid="brand-name">oRdeN</span>
      </div>
    );
  }
  // badge
  return (
    <div
      className={`flex items-center justify-center rounded-2xl overflow-hidden ${className}`}
      style={{ width: size, height: size, background: "#3e166c" }}
    >
      <img src={src} alt="oRdeN" style={{ width: size * 0.78, height: size * 0.78, objectFit: "contain", filter: "brightness(0) invert(1)" }} />
    </div>
  );
}

export default Logo;
